module.exports = __webpack_public_path__ + "static/media/1_graph4.639e86bf.svg";